import { message } from 'antd';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { addReportToMyLibraryAPI, fetchAllUserCasesAPI, fetchUserCasesByReportIdAPI } from '../../../services/user-case-service';
import { ADD_USER_CASE_TO_MY_LIBRARY, ADD_USER_CASE_TO_MY_LIBRARY_ERROR, ADD_USER_CASE_TO_MY_LIBRARY_SUCCESS, ALL_CASES_PAGINATION, FETCH_ALL_USER_CASES, FETCH_ALL_USER_CASES_ERROR, FETCH_ALL_USER_CASES_START, FETCH_ALL_USER_CASES_SUCCESS, FETCH_USER_CASES_BY_REPORT_ID, FETCH_USER_CASES_BY_REPORT_ID_ERROR, FETCH_USER_CASES_BY_VISIT_ID_SUCCESS, SET_ALL_CASES_FILTER } from '../../actions/AllCasesAction';

function* fetchAllUserCases({ payload }) {
    try {
        yield put({ type: FETCH_ALL_USER_CASES_START })
        let response = yield call(fetchAllUserCasesAPI, payload);
        if (response.success) {
            const pagination = {
                currentPage: payload.pageNo,
                pageSize: payload.pageSize,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_ALL_USER_CASES_SUCCESS, 'allCases': response.data.userCases })
            yield put({ type: ALL_CASES_PAGINATION, pagination: { ...pagination } });
            yield put({ type: SET_ALL_CASES_FILTER, searchFilter: { ...payload.userCaseRequest } });
        } else {
            yield put({ type: FETCH_ALL_USER_CASES_ERROR });
            message.error('Failed to fetch all cases!');
        }
    } catch (error) {
        message.error('Failed to fetch all cases!');
        yield put({ type: FETCH_ALL_USER_CASES_ERROR, error })
    }
}

function* addUserCaseToMyLibrary({ payload }) {
    try {
        let response = yield call(addReportToMyLibraryAPI, payload);
        if (response.success) {
            yield put({ type: ADD_USER_CASE_TO_MY_LIBRARY_SUCCESS, userCase: response.data })
            message.success('updated user case successfully.');
        }
        else {
            yield put({ type: ADD_USER_CASE_TO_MY_LIBRARY_ERROR });
            if (response.error === "query did not return a unique result: 2; nested exception is javax.persistence.NonUniqueResultException: query did not return a unique result: 2") {
                message.error('Failed to add user case to my library!');
            } else {
                message.error(response.error);
            }
        }
    } catch (error) {
        message.error(error);

    }
}


function* fetchUserCasesByReportId({ payload }) {
    try {
        let response = yield call(fetchUserCasesByReportIdAPI, payload);
        if (response.success) {
            yield put({ type: FETCH_USER_CASES_BY_VISIT_ID_SUCCESS, userCases: response.data })
        } else {
            yield put({ type: FETCH_USER_CASES_BY_REPORT_ID_ERROR });
            message.error('Failed to fetch user case!');
        }
    } catch (error) {
        message.error('Failed to fetch user case');
        yield put({ type: FETCH_USER_CASES_BY_REPORT_ID_ERROR, error })
    }
}




function* allUserCasesWatcher() {
    yield takeLatest(FETCH_ALL_USER_CASES, fetchAllUserCases)
    yield takeLatest(ADD_USER_CASE_TO_MY_LIBRARY, addUserCaseToMyLibrary)
    yield takeLatest(FETCH_USER_CASES_BY_REPORT_ID, fetchUserCasesByReportId)

}

export default function* rootSaga() {
    yield all([
        allUserCasesWatcher()
    ]);
}